const ACCESS_LEVEL_NUM = {
  GUEST: 0,
  GUEST_BILLING: 5,
  BASIC: 10,
  GOLD: 30,
  GOLD_FREE: 31,
  GOLD_PROMO: 33,
  PERFORMER: 40,
  SPECIAL_PERFORMER: 45,
  USER_MODERATOR: 47,
  COACH: 48,
  ADMIN: 50,
  SUPER_ADMIN: 60,
};

export default ACCESS_LEVEL_NUM;
